import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  DocumentTextIcon,
  FilmIcon,
  FireIcon,
  PauseIcon,
  PlayIcon,
  PresentationChartLineIcon,
  SpeakerWaveIcon,
  SpeakerXMarkIcon,
  UsersIcon,
  VariableIcon,
} from "@heroicons/react/24/outline";
import { FireIcon as FireIconSolid } from "@heroicons/react/24/solid";
import { Slider } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import ReactPlayer from "react-player/lazy";
import { useLocation } from "react-router-dom";
import codesfile from "../assets/AFL_CHAMPION_STATS_2.csv";
import { ReactComponent as AFLGoalPost } from "../assets/AFLGoalPosts.svg";
import { ReactComponent as TrackingIcon } from "../assets/Tracking.svg";
import { ReactComponent as TrackingRedIcon } from "../assets/TrackingRed.svg";
import { ReactComponent as WhistleIcon } from "../assets/Whistle.svg";
import Spinner from "../layout/Spinner";
import { decompress } from "../utils/compress";
import {
  fetchSessionDataBySessionIdPeriodIdAthleteId,
  updateMatch,
} from "../utils/dbutils";
import {
  calculateDistanceToBall,
  convertSecondsToMinutesSeconds,
  getChainData,
  processTRXFiles,
} from "../utils/Utils";
import EventsList from "./EventsList";
import Ground from "./Ground";
import MultiEventsList from "./MultiEventsList";
import PlayerStats from "./PlayerStats";

function MatchTracker() {
  const location = useLocation();
  const { match } = location.state;
  const [events, setEvents] = React.useState([]);
  const [pastEvents, setPastEvents] = React.useState([]);
  const [teamA, setTeamA] = React.useState(null);
  const [teamB, setTeamB] = React.useState(null);
  const [teamU, setTeamU] = React.useState(null);
  const [selectedPeriod, setSelectedPeriod] = React.useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [video1Url, setVideo1Url] = useState(null);
  const [video2Url, setVideo2Url] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [firstBounceVideoTime, setFirstBounceVideoTime] = useState(0);
  const [catapultOffset, setCatapultOffset] = useState(0);
  const [showNames, setShowNames] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [displayPlayer, setDisplayPlayer] = useState(null);
  const [activePlayer, setActivePlayer] = useState(null);
  const [distancePlayers, setDistancePlayers] = useState([]);
  const [heatMapPlayer, setHeatMapPlayer] = useState(null);
  const [showActivityWithHeatmap, setShowActivityWithHeatmap] = useState(false);
  const [heatmapOpacity, setHeatmapOpacity] = useState(0.7);
  const [dynamicHeatmap, setDynamicHeatmap] = useState(false);
  const [showCharts, setShowCharts] = useState(false);
  const [teamADisplayMode, setTeamADisplayMode] = useState(0);
  const [teamBDisplayMode, setTeamBDisplayMode] = useState(0);
  const [currentChainId, setCurrentChainId] = useState(null);
  const [currentChain, setCurrentChain] = useState(null);
  const [statsCodes, setStatsCodes] = useState(null);
  const [simulationSpeed, setSimulationSpeed] = useState(10);
  const [showingAllFreeKicks, setShowingAllFreeKicks] = useState(false);
  const [scores, setScores] = useState({
    homeGoals: 0,
    awayGoals: 0,
    homeBehinds: 0,
    awayBehinds: 0,
  });
  const [actionLocation, setActionLocation] = useState(null);
  const playerRef1 = React.useRef(null);
  const playerRef2 = React.useRef(null);
  const [teamListHeight, setTeamListHeight] = useState(0);
  const [umpiresListHeight, setUmpiresListHeight] = useState(0);
  const [eventListHeight, setEventListHeight] = useState(0);
  const [videoHeight, setVideoHeight] = useState(0);
  const [inited, setInited] = useState(false);
  const [selectedParameter, setSelectedParameter] = useState("Velocity");
  const [lastTeamAShow, setLastTeamAShow] = useState(null);
  const [lastTeamBShow, setLastTeamBShow] = useState(null);
  const [umpireTracking, setUmpireTracking] = useState([]);
  const parameters = [
    "Odometer",
    "Velocity",
    "Acceleration",
    "Heart Rate",
    "Player Load",
    "Metabolic Power",
    "Smooth Load",
    "Distance to Ball",
  ];

  const doDoUmpireTracking = (u, chainid) => {
    let umps = [...umpireTracking];

    if (umps.filter((x) => x.umpire.id === u.id).length > 0) {
      umps = umps.filter((x) => x.umpire.id !== u.id);
      setUmpireTracking(umps);
    } else {
      const chainevs = events.filter((e) => e["INITIAL_TRX_ID"] === chainid);
      umps.push({ umpire: u, events: chainevs, update: (n) => !n });
      setUmpireTracking(umps);
    }

    // const evs = events.filter((e) => e["INITIAL_TRX_ID"] === chainid);
    // console.log(chainid);
    // setUmpireTrackingEvents(evs);
  };

  const doUmpireTracking = (u) => {
    if (pastEvents && pastEvents.length > 0) {
      const cc = pastEvents[0]["INITIAL_TRX_ID"];
      // console.log(cc);
      doDoUmpireTracking(u, cc);
    }

    // if (u !== umpire) {
    //   setUmpire(u);
    //   if (pastEvents && pastEvents.length > 0) {
    //     const cc = pastEvents[0]["INITIAL_TRX_ID"];
    //     // console.log(cc);
    //     doDoUmpireTracking(u, cc);
    //   }
    // } else {
    //   setUmpire(null);
    //   setUmpireTrackingEvents([]);
    // }
  };

  const doShowGoals = (tm) => {
    if (tm === teamA) {
      setTeamADisplayMode(2);
      teamA.allGoalEvents = teamA.events[selectedPeriod - 1].filter(
        (e) => e["STATISTIC_CODE"] === "GOAL" || e["STATISTIC_CODE"] === "BEHI"
      );
      for (var e of teamA.allGoalEvents) {
        getChainData(e, teamA, match);
      }
    } else if (tm === teamB) {
      setTeamBDisplayMode(2);
      teamB.allGoalEvents = teamB.events[selectedPeriod - 1].filter(
        (e) => e["STATISTIC_CODE"] === "GOAL" || e["STATISTIC_CODE"] === "BEHI"
      );
      for (var e of teamB.allGoalEvents) {
        getChainData(e, teamB, match);
      }
    }
  };

  const doShowFreekicks = (tm) => {
    const fkcodes = [
      "FRAGP",
      "FRABB",
      "FRAG",
      "FRAGN",
      "FRAGO",
      "FRFOB",
      "FRFNO",
      "FRFO",
      "FRFBB",
    ];

    if (showingAllFreeKicks) {
      setShowingAllFreeKicks(false);
      teamU.freekicks = [];
      teamA.show = lastTeamAShow;
      teamB.show = lastTeamBShow;
    } else {
      setLastTeamAShow(teamA.show);
      setLastTeamBShow(teamB.show);
      teamA.show = false;
      teamB.show = false;
      setShowingAllFreeKicks(true);
      const fras = teamA.events[selectedPeriod - 1].filter((e) =>
        fkcodes.includes(e["STATISTIC_CODE"])
      );
      const frab = teamA.events[selectedPeriod - 1].filter((e) =>
        fkcodes.includes(e["STATISTIC_CODE"])
      );
      var frs = [];
      for (var e of fras) {
        getChainData(e, teamA, match);
        frs.push(e);
      }
      for (var e of frab) {
        getChainData(e, teamA, match);
        frs.push(e);
      }
      teamU.freekicks = frs;
    }
  };

  const doHeatmapPlayer = (pl) => {
    if (pl === heatMapPlayer) {
      setHeatMapPlayer(null);
    } else {
      setHeatMapPlayer(pl);
    }
  };

  const loadPlayerSensor = async (tm, selperiod) => {
    const aths = tm.catapultPlayers;
    const catsession =
      tm.name === "AFL Umpires"
        ? match.umpires_catapult_session
        : tm.name === match.home_squad
        ? match.home_catapult_session
        : match.away_catapult_session;
    if (!aths) {
      return;
    }

    if (!tm.playerSensorData) {
      tm.playerSensorData = [[], [], [], []];
    }
    if (tm.playerSensorData[selperiod - 1].length === 0) {
      setLoading(true);
      let catperiod = null;
      for (var per of catsession.periods) {
        if (per.name.toUpperCase() === `QUARTER ${selperiod}`) {
          catperiod = per;
          break;
        }
      }
      let plsds = [];
      for (var ath of aths) {
        setLoadingMessage(
          `Loading Quarter ${selperiod} sensor data for ${ath.first_name} ${ath.last_name} ...`
        );
        if (!ath.playerSensorData) {
          ath.playerSensorData = [[], [], [], []];
        }
        if (ath.playerSensorData[selperiod - 1].length > 0) {
          continue;
        }
        const sd = await fetchSessionDataBySessionIdPeriodIdAthleteId(
          catsession?.id,
          catperiod.id,
          ath.id
        );
        if (sd) {
          ath.playerSensorData[selperiod - 1] = JSON.parse(decompress(sd.data));
          plsds.push({
            id: ath.id,
            name: ath.first_name + " " + ath.last_name,
            data: JSON.parse(decompress(sd.data)),
          });
        }
      }
      tm.playerSensorData[selperiod - 1] = plsds;
      setLoading(false);
    }
  };

  const isCodePossession = (code) => {
    // find coe in statsCodes
    if (!statsCodes || statsCodes.length === 0) {
      return false;
    }
    const found = statsCodes.find((c) => c.STATISTIC_CODE === code);
    if (found) {
      return found.IS_POSSESSION === "y";
    }
    return false;
  };

  const loadStatsCodes = () => {
    if (statsCodes && statsCodes.length > 0) {
      return;
    }
    fetch(codesfile)
      .then((r) => r.text())
      .then((text) => {
        const lines = text.split(/\r?\n/);
        const headers = lines[0].split(",");
        const codes = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          const tokens = line.split(",");
          const obj = {};
          for (let j = 0; j < tokens.length; j++) {
            obj[headers[j].trim()] = tokens[j].trim();
          }
          codes.push(obj);
        }
        // console.log("codes:", codes);
        setStatsCodes(codes);
      });
  };

  const doInit = async () => {
    setLoading(true);
    const ho = localStorage.getItem("heatmapOpacity") || 0.7;
    setHeatmapOpacity(ho);
    loadStatsCodes();
    const buffer = decompress(match.buffer);
    const evs = processTRXFiles(buffer);
    setEvents(evs);
    let plsa = [];
    let plsb = [];
    let evsa = [[], [], [], []];
    let evsb = [[], [], [], []];
    let evsm = [[], [], [], []];
    let matchplsa = [];
    let matchplsb = [];
    for (var e of evs) {
      const period = e["PERIOD"] ? parseInt(e["PERIOD"]) : 0;
      if (e["SQUAD_NAME"] === match.home_squad) {
        if (plsa.filter((p) => p.id === e["PERSON_ID"]).length === 0) {
          const fullname = e["FULLNAME"];
          const plobj = { id: e["PERSON_ID"], name: fullname };
          for (var pl of match.home_athletes) {
            if (
              fullname.toUpperCase().includes(pl.first_name.toUpperCase()) &&
              fullname.toUpperCase().includes(pl.last_name.toUpperCase())
            ) {
              plobj.jersey = pl.jersey;
              plobj.athlete_id = pl.id;
              if (matchplsa.includes(pl) === false) {
                matchplsa.push(pl);
              }
              break;
            }
          }
          plsa.push(plobj);
        }
        if (period > 0) {
          evsa[period - 1].push(e);
          evsm[period - 1].push(e);
        }
      } else if (e["SQUAD_NAME"] === match.away_squad) {
        if (plsb.filter((p) => p.id === e["PERSON_ID"]).length === 0) {
          const fullname = e["FULLNAME"];
          const plobj = { id: e["PERSON_ID"], name: fullname };
          for (var pl of match.away_athletes) {
            if (
              fullname.toUpperCase().includes(pl.first_name.toUpperCase()) &&
              fullname.toUpperCase().includes(pl.last_name.toUpperCase())
            ) {
              plobj.jersey = pl.jersey;
              plobj.athlete_id = pl.id;
              if (matchplsb.includes(pl) === false) {
                matchplsb.push(pl);
              }
              break;
            }
          }
          plsb.push(plobj);
        }
        if (period > 0) {
          evsb[period - 1].push(e);
          evsm[period - 1].push(e);
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of match.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of match.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of match.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsb.length < plsb.length) {
      const nomatchplsb = plsb.filter((p) => !p.athlete_id);
      console.log(nomatchplsb);
      let leftoverplsb = [];
      for (var pl of match.away_athletes) {
        if (matchplsb.includes(pl) === false) {
          leftoverplsb.push(pl);
        }
      }
      console.log(leftoverplsb);
      for (var pl of nomatchplsb) {
        const fullname = pl.name;
        for (var plx of leftoverplsb) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsb.push(plx);
            break;
          }
        }
      }
    }
    if (!match.periods) {
      match.periods = [];
      for (var p = 1; p <= 4; p++) {
        match.periods.push({
          period: p,
          // events: evsm[p - 1],
        });
      }
    }
    setLoading(false);
    setFirstBounceVideoTime(
      parseFloat(match.periods[selectedPeriod - 1].firstBounceVideoTime) || 0
    );
    setCatapultOffset(match.periods[selectedPeriod - 1].catapultOffset || 0);
    setVideo1Url(match.periods[selectedPeriod - 1].video1Url || "");
    setVideo2Url(match.periods[selectedPeriod - 1].video2Url || "");

    const ta = {
      catapultPlayers: structuredClone(match.home_athletes),
      cdplayers: plsa,
      name: match.home_squad,
      show: true,
      events: evsa,
    };
    setTeamA(ta);
    const tb = {
      catapultPlayers: structuredClone(match.away_athletes),
      cdplayers: plsb,
      name: match.away_squad,
      show: true,
      events: evsb,
    };
    setTeamB(tb);
    await loadPlayerSensor(ta, selectedPeriod);
    await loadPlayerSensor(tb, selectedPeriod);
    if (match.umpires) {
      const tu = {
        catapultPlayers: structuredClone(match.umpires),
        cdplayers: [],
        name: "AFL Umpires",
        show: true,
        events: [[], [], [], []],
      };
      setTeamU(tu);
      await loadPlayerSensor(tu, selectedPeriod);
      const colours = [
        "rgb(106, 90, 205)",
        "rgb(255, 165, 0)",
        "rgb(238, 130, 238)",
        "rgb(255, 255, 0)",
      ];
      const textcolors = ["white", "black", "white", "black"];
      for (var nu = 0; nu < tu.catapultPlayers.length; nu++) {
        const ump = tu.catapultPlayers[nu];
        ump.fill_colour = colours[nu % colours.length];
        ump.text_colour = textcolors[nu % textcolors.length];
      }
    }
  };

  const handleLocalVideo1Load = async (event, tm) => {
    var url = URL.createObjectURL(event.target.files[0]);
    const vfp = URL.createObjectURL(event.target.files[0]);
    setVideo1Url(vfp);
  };

  const handleLocalVideo2Load = async (event, tm) => {
    var url = URL.createObjectURL(event.target.files[0]);
    const vfp = URL.createObjectURL(event.target.files[0]);
    setVideo2Url(vfp);
  };

  const handlePeriodChange = async (value) => {
    if (value === 0) {
      return;
    }
    setSelectedPeriod(value);
    await loadPlayerSensor(teamA, value);
    await loadPlayerSensor(teamB, value);
    if (teamU) {
      await loadPlayerSensor(teamU, value);
    }
    setFirstBounceVideoTime(
      parseFloat(match.periods[value - 1].firstBounceVideoTime) || 0
    );
    setCatapultOffset(parseFloat(match.periods[value - 1].catapultOffset) || 0);
    setVideo1Url(match.periods[value - 1].video1Url || "");
    setVideo2Url(match.periods[value - 1].video2Url || "");
  };

  const handleFirstBounceVideoTime = async (value) => {
    setFirstBounceVideoTime(value);
    match.periods[selectedPeriod - 1].firstBounceVideoTime = parseFloat(value);
    if (showSettings) {
      await updateMatch(match);
    }
  };

  const handleCatapultOffset = async (value) => {
    setCatapultOffset(value);
    match.periods[selectedPeriod - 1].catapultOffset = parseFloat(value);
    if (showSettings) {
      await updateMatch(match);
    }
  };

  const handleVideo1Url = async (value) => {
    setVideo1Url(value);
    match.periods[selectedPeriod - 1].video1Url = value;
    if (showSettings) {
      await updateMatch(match);
    }
  };

  const handleVideo2Url = async (value) => {
    setVideo2Url(value);
    match.periods[selectedPeriod - 1].video2Url = value;
    if (showSettings) {
      await updateMatch(match);
    }
  };

  const doUpdateSensorData = async (sdata) => {
    for (var pl of teamA.catapultPlayers) {
      if (pl.id === sdata.athleteId) {
        pl.sensorData = sdata.sd;
        // console.log(pl.first_name + " " + pl.last_name, sdata.sd);
        return;
      }
    }
    for (var pl of teamB.catapultPlayers) {
      if (pl.id === sdata.athleteId) {
        pl.sensorData = sdata.sd;
        // console.log(pl.first_name + " " + pl.last_name, sdata.sd);
        return;
      }
    }
    for (var pl of teamU?.catapultPlayers) {
      if (pl.id === sdata.athleteId) {
        pl.sensorData = sdata.sd;
        // console.log(pl.first_name + " " + pl.last_name, sdata.sd);
        return;
      }
    }
  };

  const doSelectEvent = async (e) => {
    playerRef1.current.seekTo(
      parseFloat(e["PERIOD_SECS"]) + parseFloat(firstBounceVideoTime)
    );
    playerRef2.current.seekTo(
      parseFloat(e["PERIOD_SECS"]) + parseFloat(firstBounceVideoTime)
    );
  };

  const isPossessionEvent = (e) => {
    if (
      e["STATISTIC_CODE"].substring(0, 2) === "KK" ||
      e["STATISTIC_CODE"].substring(0, 2) === "HB"
    ) {
      return true;
    }
  };

  const getAthleteInEvent = (e) => {
    if (!e || !e["PERSON_ID"]) {
      return null;
    }
    const plid = e["PERSON_ID"];
    const pls = teamA.cdplayers.filter((p) => {
      return p.id === plid;
    });
    if (pls.length > 0) {
      return pls[0];
    }
    const pls2 = teamB.cdplayers.filter((p) => {
      return p.id === plid;
    });
    if (pls2.length > 0) {
      return pls2[0];
    }
    return null;
  };

  useLayoutEffect(() => {
    calculateDimensions();
  }, []);

  useEffect(() => {
    if (!inited) {
      doInit();
      setInited(true);
    }

    function handleWindowResize() {
      calculateDimensions();
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [match]);

  useEffect(() => {
    const evs = events.filter(
      (e) =>
        e["PERIOD"] === selectedPeriod.toString() &&
        parseFloat(e["PERIOD_SECS"]) <= videoProgress - firstBounceVideoTime
    );
    const sortedpe = evs.sort((a, b) => b["ORDER"] - a["ORDER"]);

    setPastEvents(sortedpe);
    for (var e of sortedpe) {
      if (
        e["STATISTIC_CODE"] === "OOBO" ||
        (e["STATISTIC_CODE"].length >= 4 &&
          e["STATISTIC_CODE"].substring(0, 4) === "RUSH")
      ) {
        const app = {
          statscode: e["STATISTIC_CODE"],
          sensorData: activePlayer?.sensorData,
        };
        // console.log(app);
        setActivePlayer(app);
        break;
      } else if (isCodePossession(e["STATISTIC_CODE"])) {
        const lastev = e;
        const ap = getAthleteInEvent(lastev);
        if (ap) {
          let apx = teamA.catapultPlayers.find((p) => p.id === ap.athlete_id);
          if (!apx) {
            apx = teamB.catapultPlayers.find((p) => p.id === ap.athlete_id);
          }
          if (apx && apx.sensorData) {
            apx.statscode = lastev["STATISTIC_CODE"];
            setActivePlayer(apx);
            // ap.sensorData = apx?.sensorData;
            // ap.statscode = lastev["STATISTIC_CODE"];
            // setActivePlayer(ap);
            // console.log(
            //   ap.jersey,
            //   ap.name,
            //   ap.statscode,
            //   ap.sensorData.x,
            //   ap.sensorData.y
            // );
            break;
          }
        }
        break;
      } else {
        setActivePlayer(null);
      }
    }
    // let cc = { events: [], id: null };
    // let lastc = null;
    // for (var ne = 0; ne < sortedpe.length; ne++) {
    //   const e = sortedpe[ne];
    //   const trxid = e["INITIAL_TRX_ID"];
    //   if (lastc && trxid !== lastc) {
    //     cc.id = lastc;
    //     setCurrentChain(cc);
    //     if (umpire && currentChain?.id !== trxid) {
    //       doDoUmpireTracking(umpire, lastc);
    //     }
    //     break;
    //   }
    //   cc.id = trxid;
    //   const fullname = e["FULLNAME"];
    //   if (fullname.length > 0) {
    //     if (isPossessionEvent(e)) {
    //       const plobj =
    //         e["SQUAD_NAME"] === teamA.name
    //           ? teamA.cdplayers.filter((pl) => pl.name === fullname)
    //           : teamB.cdplayers.filter((pl) => pl.name === fullname);
    //       if (plobj.length > 0) {
    //         cc.events.push({ athleteId: plobj[0].athlete_id, event: e });
    //       }
    //     }
    //   } else {
    //     setCurrentChain(cc);
    //     cc = { events: [], id: null };
    //   }
    //   lastc = trxid;
    // }
    // setCurrentChain(cc);

    const itrxid = sortedpe.length > 0 ? sortedpe[0]["INITIAL_TRX_ID"] : null;
    if (currentChainId !== itrxid) {
      setCurrentChainId(itrxid);
      // doDoUmpireTracking(umpire, itrxid);
      for (var ut of umpireTracking) {
        ut.events = events.filter((e) => e["INITIAL_TRX_ID"] === itrxid);
        ut.update = (n) => !n;
      }
    }

    let ttagoals = 0;
    let ttbgoals = 0;
    let ttabehinds = 0;
    let ttbbehinds = 0;
    for (var np = 1; np < selectedPeriod; np++) {
      let ptagoals = events.filter(
        (e) =>
          e["PERIOD"] === np.toString() &&
          e["STATISTIC_CODE"] === "GOAL" &&
          e["SQUAD_NAME"] === match.home_squad
      );
      let ptbgoals = events.filter(
        (e) =>
          e["PERIOD"] === np.toString() &&
          e["STATISTIC_CODE"] === "GOAL" &&
          e["SQUAD_NAME"] === match.away_squad
      );
      let ptabehinds = events.filter(
        (e) =>
          e["PERIOD"] === np.toString() &&
          (e["STATISTIC_CODE"] === "BEHI" ||
            e["STATISTIC_CODE"].substring(0, 3) === "RUS") &&
          e["SQUAD_NAME"] === match.home_squad
      );
      let ptbbehinds = events.filter(
        (e) =>
          e["PERIOD"] === np.toString() &&
          (e["STATISTIC_CODE"] === "BEHI" ||
            e["STATISTIC_CODE"].substring(0, 3) === "RUS") &&
          e["SQUAD_NAME"] === match.away_squad
      );
      ttagoals += ptagoals.length;
      ttbgoals += ptbgoals.length;
      ttabehinds += ptabehinds.length;
      ttbbehinds += ptbbehinds.length;
    }

    let tagoals = evs.filter(
      (e) =>
        e["STATISTIC_CODE"] === "GOAL" && e["SQUAD_NAME"] === match.home_squad
    );
    let tbgoals = evs.filter(
      (e) =>
        e["STATISTIC_CODE"] === "GOAL" && e["SQUAD_NAME"] === match.away_squad
    );
    let tabehinds = evs.filter(
      (e) =>
        (e["STATISTIC_CODE"] === "BEHI" ||
          e["STATISTIC_CODE"].substring(0, 3) === "RUS") &&
        e["SQUAD_NAME"] === match.home_squad
    );
    let tbbehinds = evs.filter(
      (e) =>
        (e["STATISTIC_CODE"] === "BEHI" ||
          e["STATISTIC_CODE"].substring(0, 3) === "RUS") &&
        e["SQUAD_NAME"] === match.away_squad
    );
    ttagoals += tagoals.length;
    ttbgoals += tbgoals.length;
    ttabehinds += tabehinds.length;
    ttbbehinds += tbbehinds.length;
    setScores({
      homeGoals: ttagoals,
      awayGoals: ttbgoals,
      homeBehinds: ttabehinds,
      awayBehinds: ttbbehinds,
    });
  }, [videoProgress, heatMapPlayer, teamADisplayMode]);

  useEffect(() => {}, [showSettings, isMuted, isPlaying, umpireTracking]);

  const getSensorData = (athlete) => {
    if (athlete.sensorData) {
      if (selectedParameter === "Odometer") {
        return athlete.sensorData.o.toFixed(2);
      } else if (selectedParameter === "Velocity") {
        return athlete.sensorData.v.toFixed(2);
      } else if (selectedParameter === "Acceleration") {
        return athlete.sensorData.a.toFixed(2);
      } else if (selectedParameter === "Heart Rate") {
        return athlete.sensorData.hr.toFixed(2);
      } else if (selectedParameter === "Player Load") {
        return athlete.sensorData.pl.toFixed(2);
      } else if (selectedParameter === "Metabolic Power") {
        return athlete.sensorData.mp.toFixed(2);
      } else if (selectedParameter === "Smooth Load") {
        return athlete.sensorData.sl.toFixed(2);
      } else if (selectedParameter === "Distance to Ball") {
        const starttime =
          match.home_catapult_session?.periods[selectedPeriod - 1].start_time +
          catapultOffset;
        const currentTime = starttime + videoProgress;

        return calculateDistanceToBall(
          athlete,
          activePlayer,
          selectedPeriod,
          currentTime
        );
      }
    }
    return "";
  };

  const doTeamPanel = async (tm, idx) => {
    if (tm === teamA) {
      setTeamADisplayMode(idx);
    } else {
      setTeamBDisplayMode(idx);
    }
  };

  const isPlayerSelected = (athlete) => {
    if (selectedPlayers.filter((p) => p.id === athlete.id).length > 0) {
      return true;
    }
    return false;
  };

  const showTeamPanel = (tm) => {
    if (tm === teamA && teamA?.show === true) {
      if (teamADisplayMode === 0) {
        return (
          <>
            <div
              className="flex-col overflow-auto shadow-lg bg-base-200/80"
              style={{ height: teamListHeight }}
            >
              {teamA?.catapultPlayers
                ?.sort((a, b) => a.jersey - b.jersey)
                .map((p, idx) => (
                  <div
                    className={
                      idx % 2 !== 0
                        ? "flex justify-between cursor-pointer"
                        : "flex justify-between bg-base-300/50 cursor-pointer"
                    }
                    onClick={() => {
                      doSelectPlayer(p);
                    }}
                  >
                    <div
                      key={p.id}
                      className={
                        isPlayerSelected(p)
                          ? "text-sm text-red-600 px-1 py-0.5 font-medium"
                          : "text-sm px-1 py-0.5 font-medium"
                      }
                    >
                      {p.jersey}. {p.first_name} {p.last_name}{" "}
                    </div>
                    <div className="flex gap-2">
                      <div className="text-sm px-1 py-0.5 font-medium">
                        {getSensorData(p)}
                      </div>
                      {heatMapPlayer === p ? (
                        <FireIconSolid
                          className="h-5 w-5 mt-1 text-red-600 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            doHeatmapPlayer(p);
                          }}
                        />
                      ) : (
                        <FireIcon
                          className="h-5 w-5 mt-1 text-base-content cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            doHeatmapPlayer(p);
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </>
        );
      } else if (teamADisplayMode === 1) {
        return (
          <EventsList
            match={match}
            team={teamA}
            events={teamA.events[selectedPeriod - 1]}
            onSelectEvent={(ev) => doSelectEvent(ev)}
          />
        );
      } else if (teamADisplayMode === 2) {
        return (
          <MultiEventsList
            match={match}
            team={teamA}
            events={teamA.allGoalEvents}
            onSelectEvent={(ev) => doSelectEvent(ev)}
          />
        );
      }
    } else if (tm === teamB && teamB?.show === true) {
      if (teamBDisplayMode === 0) {
        return (
          <>
            <div
              className="flex-col overflow-auto shadow-lg bg-base-200/80"
              style={{ height: teamListHeight }}
            >
              {teamB?.catapultPlayers
                ?.sort((a, b) => a.jersey - b.jersey)
                .map((p, idx) => (
                  <div
                    className={
                      idx % 2 !== 0
                        ? "flex justify-between cursor-pointer"
                        : "flex justify-between bg-base-300/50 cursor-pointer"
                    }
                    onClick={() => {
                      doSelectPlayer(p);
                    }}
                  >
                    <div
                      key={p.id}
                      className={
                        isPlayerSelected(p)
                          ? "text-sm text-red-600 px-1 py-0.5 font-medium"
                          : "text-sm px-1 py-0.5 font-medium"
                      }
                    >
                      {p.jersey}. {p.first_name} {p.last_name}{" "}
                    </div>
                    <div className="flex gap-2">
                      <div className="text-sm px-1 py-0.5 font-medium">
                        {getSensorData(p)}
                      </div>
                      {heatMapPlayer === p ? (
                        <FireIconSolid
                          className="h-5 w-5 mt-1 text-red-600 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            doHeatmapPlayer(p);
                          }}
                        />
                      ) : (
                        <FireIcon
                          className="h-5 w-5 mt-1 text-base-content cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            doHeatmapPlayer(p);
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </>
        );
      } else if (teamBDisplayMode === 1) {
        return (
          <EventsList
            match={match}
            team={teamB}
            events={teamB.events[selectedPeriod - 1]}
            onSelectEvent={(ev) => doSelectEvent(ev)}
          />
        );
      } else if (teamADisplayMode === 2) {
        return (
          <MultiEventsList
            match={match}
            team={teamB}
            events={teamB.allGoalEvents}
            onSelectEvent={(ev) => doSelectEvent(ev)}
          />
        );
      }
    } else if (tm === teamU) {
      return (
        <div
          className="flex-col overflow-auto shadow-lg bg-base-200/80"
          // style={{ height: umpiresListHeight }}
        >
          {teamU?.catapultPlayers
            ?.sort((a, b) => a.jersey - b.jersey)
            .map((p, idx) => (
              <div
                key={p.id}
                className={
                  idx % 2 !== 0
                    ? "flex justify-between cursor-pointer"
                    : "flex justify-between bg-base-300/50 cursor-pointer"
                }
                onClick={() => {
                  doSelectPlayer(p);
                }}
              >
                <div className="flex gap-2">
                  <div
                    className="w-5 h-5 text-center mt-1 ml-1"
                    style={{
                      backgroundColor: p.fill_colour,
                      color: p.text_colour,
                      borderRadius: "50%",
                    }}
                  >
                    {p.jersey}
                  </div>
                  <div
                    className={
                      isPlayerSelected(p)
                        ? "text-sm text-red-600 px-1 py-0.5 font-medium"
                        : "text-sm px-1 py-0.5 font-medium"
                    }
                  >
                    {p.first_name} {p.last_name}{" "}
                  </div>
                </div>
                <div className="flex gap-2">
                  <div className="text-sm px-1 py-0.5 font-medium">
                    {getSensorData(p)}
                  </div>
                  <div className="flex gap-2">
                    {umpireTracking.filter((x) => x.umpire.id === p.id).length >
                    0 ? (
                      <TrackingRedIcon
                        className="h-5 w-5 mt-1 text-red-600 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          doUmpireTracking(p);
                        }}
                      />
                    ) : (
                      <TrackingIcon
                        className="h-5 w-5 mt-1 text-red-600 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          doUmpireTracking(p);
                        }}
                      />
                    )}

                    {heatMapPlayer === p ? (
                      <FireIconSolid
                        className="h-5 w-5 mt-1 text-red-600 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          doHeatmapPlayer(p);
                        }}
                      />
                    ) : (
                      <FireIcon
                        className="h-5 w-5 mt-1 text-base-content cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          doHeatmapPlayer(p);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          {showingAllFreeKicks ? (
            <MultiEventsList
              match={match}
              team={teamU}
              events={teamU.freekicks}
              onSelectEvent={(ev) => doSelectEvent(ev)}
            />
          ) : (
            <></>
          )}
        </div>
      );
    }
  };

  const doSelectPlayer = (athlete) => {
    if (selectedPlayers.filter((p) => p.id === athlete.id).length > 0) {
      const pls = selectedPlayers.filter((p) => p.id !== athlete.id);
      setSelectedPlayers(pls);
      if (selectedParameter === "Distance to Ball") {
        setDistancePlayers(pls);
      } else {
        setDistancePlayers([]);
      }
      setDisplayPlayer(pls.length > 0 ? pls[0] : null);
    } else {
      const pls = [...selectedPlayers, athlete];
      setSelectedPlayers(pls);
      setDisplayPlayer(athlete);
      setDistancePlayers(pls);
    }
  };

  const getPlayerJersey = (e) => {
    const plid = e["PERSON_ID"];
    const pl = teamA.cdplayers.filter((p) => p.id === plid);
    if (pl.length > 0) {
      return pl[0].jersey;
    }
    const pl2 = teamB.cdplayers.filter((p) => p.id === plid);
    if (pl2.length > 0) {
      return pl2[0].jersey;
    }
    return "";
  };

  let tth = 88;
  const calculateDimensions = () => {
    let wh = window.innerHeight - tth - 100;
    if (match.umpires) {
      setUmpiresListHeight(100);
      wh -= 140;
    } else {
      setUmpiresListHeight(0);
    }
    setTeamListHeight(wh / 2);
    const xh = 580 + 36 + 36;
    const wh2 = window.innerHeight - xh - 38;
    setEventListHeight(wh2);
    const controlsHeight =
      document.getElementById("video-controls")?.offsetHeight;
    const wh3 = window.innerHeight - controlsHeight - 20;
    setVideoHeight(wh3 / 2);
  };

  const refTop = useCallback((node) => {
    if (!node) return;
    const resizeObserver = new ResizeObserver(() => {
      const rect = node.getBoundingClientRect();
      tth = rect.height;
      let h = window.innerHeight - rect.height - 100;
      if (match.umpires) {
        setUmpiresListHeight(100);
        h -= 140;
      } else {
        setUmpiresListHeight(0);
      }
      setTeamListHeight(h / 2);
    });
    resizeObserver.observe(node);
  }, []);

  const toggleShowSettings = () => {
    setShowSettings(!showSettings);
    calculateDimensions();
  };

  if (loading) {
    return (
      <>
        <div className="w-full h-[98vh] bg-base-100 flex justify-center items-center">
          <Spinner className="p2" message={loadingMessage} />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flex gap-2 text-sm">
        <div className="flex-col w-[320px] min-w-[320px] max-w-[480px]">
          <div className="flex-col" ref={refTop}>
            <div className="border-base-200 border p-2 mt-1">
              <div className="flex-col">
                <div className="flex justify-between">
                  <select
                    className="select-generic w-32 max-w-xs"
                    value={
                      match.home_catapult_session?.periods[selectedPeriod - 1]
                        .name
                    }
                    onChange={(e) => {
                      handlePeriodChange(e.target.selectedIndex);
                    }}
                  >
                    <option value={0}>Select Period</option>
                    {match.home_catapult_session?.periods.map((p) => (
                      <option key={p.id} value={p.name}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  <>
                    {showSettings ? (
                      <ChevronUpIcon
                        className="size-5 text-base-content cursor-pointer"
                        onClick={() => toggleShowSettings()}
                      />
                    ) : (
                      <ChevronDownIcon
                        className="size-5 text-base-content cursor-pointer"
                        onClick={() => toggleShowSettings()}
                      />
                    )}
                  </>
                </div>
                <>
                  {showSettings ? (
                    <>
                      <div className="flex-col">
                        <div className="flex gap-2 mt-1">
                          <div className="text-xs w-20">1st Bounce</div>
                          <div className="text-xs">Sensor Offset</div>
                        </div>
                        <div className="flex gap-2">
                          <input
                            type="text"
                            className="input-generic w-20 max-w-xs"
                            value={firstBounceVideoTime}
                            onChange={(e) => {
                              handleFirstBounceVideoTime(e.target.value);
                            }}
                            placeholder="First Bounce"
                          />
                          <input
                            type="text"
                            className="input-generic w-full max-w-xs"
                            value={catapultOffset}
                            onChange={(e) => {
                              handleCatapultOffset(e.target.value);
                            }}
                            placeholder="Sensor start time offset"
                          />
                        </div>
                        <div className="flex gap-2 mt-1">
                          <div className="text-xs">Video 1 URL</div>
                        </div>
                        <div className="flex gap-1">
                          <input
                            type="text"
                            className="input-generic max-w-xs"
                            value={video1Url}
                            onChange={(e) => {
                              handleVideo1Url(e.target.value);
                            }}
                            placeholder="Video 1 URL"
                          />
                          <input
                            type="file"
                            id="selectedVideoFile1"
                            style={{ display: "none" }}
                            onChange={handleLocalVideo1Load}
                            onClick={(event) => {
                              event.target.value = null;
                            }}
                          />
                          <FilmIcon
                            className="size-6 btn-toolbar mt-2 cursor-pointer"
                            onClick={() =>
                              document
                                .getElementById("selectedVideoFile1")
                                .click()
                            }
                          />
                        </div>
                        <div className="flex gap-2 mt-1">
                          <div className="text-xs">Video 2 URL</div>
                        </div>
                        <div className="flex gap-1">
                          <input
                            type="text"
                            className="input-generic max-w-xs"
                            value={video2Url}
                            onChange={(e) => {
                              handleVideo2Url(e.target.value);
                            }}
                            placeholder="Video 2 URL"
                          />
                          <input
                            type="file"
                            id="selectedVideoFile2"
                            style={{ display: "none" }}
                            onChange={handleLocalVideo2Load}
                            onClick={(event) => {
                              event.target.value = null;
                            }}
                          />
                          <FilmIcon
                            className="size-6 btn-toolbar mt-2 cursor-pointer"
                            onClick={() =>
                              document
                                .getElementById("selectedVideoFile2")
                                .click()
                            }
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </div>
            </div>
            {selectedPlayers.length > 0 ? (
              <div className="flex-col">
                <div className="flex justify-between text-lg font-bold">
                  <ChevronLeftIcon
                    className="size-6 text-base-content cursor-pointer"
                    onClick={() => {
                      const index = selectedPlayers.indexOf(displayPlayer);
                      if (index === 0) {
                        setDisplayPlayer(
                          selectedPlayers[selectedPlayers.length - 1]
                        );
                      } else {
                        setDisplayPlayer(selectedPlayers[index - 1]);
                      }
                    }}
                  />
                  {displayPlayer?.first_name} {displayPlayer?.last_name}
                  <div className="flex gap-2">
                    <>
                      {showCharts ? (
                        <VariableIcon
                          className="size-6 text-base-content cursor-pointer"
                          onClick={() => setShowCharts(false)}
                        />
                      ) : (
                        <PresentationChartLineIcon
                          className="size-6 text-base-content cursor-pointer"
                          onClick={() => setShowCharts(true)}
                        />
                      )}
                    </>{" "}
                    <ChevronRightIcon
                      className="size-6 text-base-content cursor-pointer"
                      onClick={() => {
                        const index = selectedPlayers.indexOf(displayPlayer);
                        if (index === selectedPlayers.length - 1) {
                          setDisplayPlayer(selectedPlayers[0]);
                        } else {
                          setDisplayPlayer(selectedPlayers[index + 1]);
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="flex-col w-[320px] bg-base-100">
                  <PlayerStats
                    player={displayPlayer}
                    period={selectedPeriod}
                    showCharts={showCharts}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <select
              id="params"
              className="select-generic max-w-xs mt-2"
              value={selectedParameter}
              onChange={(e) => {
                setSelectedParameter(e.target.value);
              }}
            >
              {parameters.map((p, idx) => (
                <option key={idx} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-col gap-2 mt-2">
            <div className="flex-col w-full bg-base-100">
              <div className="flex-row">
                <div className="flex justify-between">
                  <div className="flex gap-2 p-1 text-sm font-bold">
                    <input
                      type="checkbox"
                      checked={teamA?.show}
                      className="checkbox-generic mr-2 "
                      onChange={() => {
                        teamA.show = !teamA.show;
                      }}
                    />
                    {match.home_squad.toUpperCase()}
                  </div>
                  <flex className="flex gap-2">
                    <AFLGoalPost
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => {
                        doShowGoals(teamA);
                      }}
                    />
                    <UsersIcon
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => doTeamPanel(teamA, 0)}
                    />
                    <DocumentTextIcon
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => doTeamPanel(teamA, 1)}
                    />
                  </flex>
                </div>
                {showTeamPanel(teamA)}
              </div>
            </div>
            <div className="flex-col w-full bg-base-100 mt-4">
              <div className="flex-row">
                <div className="flex justify-between">
                  <div className="flex gap-2 p-1 text-sm font-bold">
                    <input
                      type="checkbox"
                      checked={teamB?.show}
                      className="checkbox-generic mr-2 "
                      onChange={() => {
                        teamB.show = !teamB.show;
                      }}
                    />
                    {match.away_squad.toUpperCase()}
                  </div>
                  <flex className="flex gap-2">
                    <AFLGoalPost
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => {
                        doShowGoals(teamB);
                      }}
                    />
                    <UsersIcon
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => doTeamPanel(teamB, 0)}
                    />
                    <DocumentTextIcon
                      className="h-5 w-5 text-base-content cursor-pointer"
                      onClick={() => doTeamPanel(teamB, 1)}
                    />
                  </flex>
                </div>
                {showTeamPanel(teamB)}
              </div>
            </div>
            {teamU ? (
              <div className="flex-col w-full bg-base-100 mt-4">
                <div className="flex-row">
                  <div className="flex justify-between p-1">
                    {/* <div className="flex gap-2 p-1 text-sm font-bold">
                      <div className="flex justify-between"> */}
                    <div className="flex gap-2">
                      <input
                        type="checkbox"
                        checked={teamU?.show}
                        className="checkbox-generic mr-2 "
                        onChange={() => {
                          teamU.show = !teamU.show;
                        }}
                      />
                      {teamU.name.toUpperCase()}
                    </div>
                    <div className="flex gap-2">
                      <div className="">
                        <WhistleIcon
                          className="h-5 w-5 text-base-content cursor-pointer"
                          onClick={() => {
                            doShowFreekicks(teamA);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
                  </div> */}
                  {showTeamPanel(teamU)}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="flex-col text-sm  w-[400px] min-w-[400px] max-w-[400px]">
          <div className="flex-col w-full bg-base-100">
            <div className="flex-col p-2">
              <div className="flex gap-1">
                <div
                  className="w-4 h-4 mt-0.5"
                  style={{ backgroundColor: "blue" }}
                ></div>
                <h2 className="font-bold w-40 px-1">
                  {match.home_squad.toUpperCase()}
                </h2>
                <div className="px-1 font-medium">
                  {scores.homeGoals} - {scores.homeBehinds} -{" "}
                  {scores.homeGoals * 6 + scores.homeBehinds}
                </div>
              </div>
              <div className="flex gap-1">
                <div
                  className="w-4 h-4 mt-0.5"
                  style={{ backgroundColor: "cyan" }}
                ></div>
                <h2 className="font-bold w-40 px-1">
                  {match.away_squad.toUpperCase()}
                </h2>
                <div className="px-1 font-medium">
                  {scores.awayGoals} - {scores.awayBehinds} -{" "}
                  {scores.awayGoals * 6 + scores.awayBehinds}
                </div>
              </div>
            </div>
          </div>
          <Ground
            panelSize={{ width: 400, height: 580 }}
            groundSize={{
              width: match.venueWidth,
              height: match.venueLength,
            }}
            match={match}
            teamA={teamA}
            teamB={teamB}
            teamU={teamU}
            selectedPeriod={selectedPeriod}
            videoProgress={videoProgress}
            catapultOffset={parseFloat(catapultOffset)}
            showNames={showNames}
            selectedPlayers={selectedPlayers}
            currentChain={currentChain}
            activePlayer={activePlayer}
            distancePlayers={distancePlayers}
            heatMapPlayer={heatMapPlayer}
            showActivityWithHeatmap={showActivityWithHeatmap}
            heatmapOpacity={heatmapOpacity}
            dynamicHeatmap={dynamicHeatmap}
            umpireTracking={umpireTracking}
            simulationSpeed={simulationSpeed}
            onSensorData={(sdata) => doUpdateSensorData(sdata)}
          />
          <div
            className="flex-col"
            style={{
              position: "absolute",
              bottom: "10px",
              left: "344px",
              width: "400px",
            }}
          >
            <div className="flex gap-2">
              {heatMapPlayer ? (
                <div className="flex justify-between w-full">
                  <label className="label text-sm gap-2">
                    <input
                      type="checkbox"
                      checked={showActivityWithHeatmap}
                      className="checkbox-generic"
                      onChange={() => {
                        setShowActivityWithHeatmap(!showActivityWithHeatmap);
                      }}
                    />
                    Show Activities
                  </label>
                  <div className="flex gap-2">
                    <label className="label text-sm gap-2">
                      <input
                        type="checkbox"
                        checked={dynamicHeatmap}
                        className="checkbox-generic"
                        onChange={() => {
                          setDynamicHeatmap(!dynamicHeatmap);
                        }}
                      />
                      Dynamic
                    </label>
                  </div>
                  <div className="flex gap-2">
                    <label className="label text-sm">Opacity</label>
                    <input
                      type="number"
                      value={heatmapOpacity}
                      step={0.1}
                      min={0.1}
                      max={1.0}
                      className="underline-input w-16"
                      onChange={(event) => {
                        setHeatmapOpacity(parseFloat(event.target.value));
                        localStorage.setItem(
                          "heatmapOpacity",
                          event.target.value
                        );
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex justify-between w-full">
                  <div className="flex gap-2">
                    <label className="label text-sm gap-2">
                      <input
                        type="checkbox"
                        checked={showNames}
                        className="checkbox-generic"
                        onChange={() => {
                          setShowNames(!showNames);
                        }}
                      />
                      Show Names
                    </label>
                  </div>
                  <div className="flex gap-2">
                    {umpireTracking.length > 0 ? (
                      <div className="flex gap-2">
                        <label className="label text-sm">Simulate Speed</label>
                        <input
                          type="number"
                          className="input-generic w-16"
                          max={100}
                          min={1}
                          value={simulationSpeed}
                          onChange={(event) => {
                            setSimulationSpeed(parseFloat(event.target.value));
                          }}
                        />
                        <label className="label text-sm">%</label>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              className="flex-col overflow-auto mt-1 shadow-lg bg-base-200/80"
              style={{ height: eventListHeight }}
            >
              <table className="table-auto w-full">
                <thead>
                  <tr>
                    <th className="text-left">Player</th>
                    <th className="text-left">Time</th>
                    <th className="text-left">Event</th>
                    <th className="text-left">Chain</th>
                  </tr>
                </thead>
                <tbody>
                  {pastEvents.map((e, idx) => (
                    <tr
                      key={idx}
                      className={
                        idx % 2 !== 0
                          ? "px-1 py-0.5 cursor-pointer"
                          : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                      }
                      onClick={() => {
                        doSelectEvent(e);
                      }}
                    >
                      <td>
                        {getPlayerJersey(e)}. {e["FULLNAME"]}
                      </td>
                      <td className="text-left">
                        {convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}
                      </td>
                      <td>{e["STATISTIC_CODE"]}</td>
                      <td>{e["INITIAL_TRX_ID"]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="flex-col w-full p-2 bg-base-100">
          <div className="w-full bg-black" style={{ height: videoHeight }}>
            <ReactPlayer
              ref={playerRef1}
              url={video1Url}
              playing={isPlaying}
              controls={false}
              progressInterval={200}
              onProgress={(progress) => {
                setVideoProgress(progress.playedSeconds);
              }}
              width="100%"
              height="100%"
              muted={isMuted}
            />
          </div>
          <div
            id="video-controls"
            className="flex gap-1 h-10 w-full p-2 bg-base-100"
          >
            {isPlaying ? (
              <PauseIcon
                className="size-6 text-base-content cursor-pointer"
                onClick={() => setIsPlaying(false)}
              />
            ) : (
              <PlayIcon
                className="size-6 text-base-content cursor-pointer"
                onClick={() => setIsPlaying(true)}
              />
            )}
            <ChevronDoubleLeftIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress - 10;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <ChevronLeftIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress - 1;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <ArrowLeftCircleIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress - 0.03;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <ArrowRightCircleIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress + 0.03;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <ChevronRightIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress + 1;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <ChevronDoubleRightIcon
              className="size-6 text-base-content cursor-pointer"
              onClick={() => {
                const newTime = videoProgress + 10;
                setVideoProgress(newTime);
                playerRef1.current.seekTo(newTime);
                playerRef2.current.seekTo(newTime);
              }}
            />
            <div className="flex gap-4 w-full mr-4">
              <Slider
                className="ml-4 text-base-content"
                size="small"
                color="oklch(var(--bc))"
                value={videoProgress}
                max={playerRef1.current?.getDuration() || 0}
                onChange={(e) => {
                  setVideoProgress(e.target.value);
                  playerRef1.current.seekTo(e.target.value);
                  playerRef2.current.seekTo(e.target.value);
                }}
                // onMouseUp={(e) => {
                //   setVideoProgress(e.target.value);
                //   playerRef1.current.seekTo(e.target.value);
                //   playerRef2.current.seekTo(e.target.value);
                // }}
              />
              <div className="text-xs mt-2">
                {convertSecondsToMinutesSeconds(videoProgress)}
              </div>
              <>
                {isMuted ? (
                  <SpeakerWaveIcon
                    className="size-6 text-base-content cursor-pointer"
                    onClick={() => setIsMuted(false)}
                  />
                ) : (
                  <SpeakerXMarkIcon
                    className="size-6 text-base-content cursor-pointer"
                    onClick={() => setIsMuted(true)}
                  />
                )}
              </>
            </div>
          </div>
          <div className="w-full bg-black" style={{ height: videoHeight }}>
            <ReactPlayer
              ref={playerRef2}
              url={video2Url}
              playing={isPlaying}
              controls={false}
              width="100%"
              height="100%"
              muted={isMuted}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default MatchTracker;
